// 003 (FR-027, FR-028; P-AUTH-2; research R7): wraps parent Home. A parent with no children goes
// to /join/<CODE> when a pending join exists, else to the non-skippable Enter school code step.
// While probing it shows a loading state (no Home flash); any failure shows Home (FR-028).
import { useRouter } from "expo-router";
import { type ReactNode, useEffect, useState } from "react";

import { useSession } from "@/session/hooks";
import { StateView } from "@/shell/StateView";

import { useJoinClient } from "./joinApi";
import { pendingJoin } from "./pendingJoin";
import { studentsProbe } from "./studentsProbe";

export function ParentHomeGate({ children }: { children: ReactNode }) {
  const router = useRouter();
  const client = useJoinClient();
  const session = useSession();
  const userKey = session.status === "signedIn" ? session.user.displayName : "";
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let live = true;
    void (async () => {
      const presence = await studentsProbe.check(
        () => client.listMyStudents(),
        userKey,
      );
      if (!live) return;
      if (presence !== "none") {
        setOpen(true);
        return;
      }
      const pending = await pendingJoin.read();
      if (!live) return;
      router.replace(
        pending ? `/join/${pending.code}` : "/enter-school-code?mode=required",
      );
    })();
    return () => {
      live = false;
    };
  }, [client, userKey, router]);

  return open ? <>{children}</> : <StateView status="loading" />;
}
